<template>
  <div class='article-list'>
    <article class="article" :class="{
      featured: i === 0,
      standard: i !== 0,
      unneeded: i === articles.length - 1,
    }" v-for="(article, i) in articles" :key="article.id">
      <a class="article-link" :href="article.url" />
      <img class="article-image":src="article.image" loading="lazy" />
      <div class="article-text">
        <h3 class="article-title">{{ article.title }}</h3>
        <template>
          <CmTruncatedText v-if="i === 0" class="article-excerpt">
            <div v-html="article.excerpt" />
          </CmTruncatedText>
          <p v-else class="article-excerpt" v-html="article.excerpt" />
        </template>
        <div class="cta-link">Read more</div>
      </div>
    </article>
  </div>
</template>

<script>
import axios from 'axios';
import CmTruncatedText from '../components/cm-truncated-text';

export default {
  components: {
    CmTruncatedText
  },

  data() {
    return {
      results: null,
    };
  },

  computed: {
    articles() {
      if (this.results) {
        return this.results.data
      }
    }
  },

  created() {
    this.isLoading = true;

    axios.get('/blog/featured.json')
      .then(response => {
        this.isLoading = false;
        this.results = response;
      });
  },
};
</script>


// WEBPACK FOOTER //
// app/javascript/components/featured-articles.vue?384903ad